export default __webpack_public_path__ + "static/me-b2dd4a3e21000d89daa3964854e707cb.jpg";